import Slider, { type Settings } from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { IconButton } from "@mui/material";
import {
  ArrowBackIosNewRounded,
  ArrowForwardIosRounded,
} from "@mui/icons-material";

import { dmeConfig } from "dmeditor";
import { useEffect, useState } from "react";

export function CollegeSlider(props: { list: Array<any> }) {
  const settings: Settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow: (
      <div>
        <IconButton
          className="text-gray-400 hover:bg-inherit relative bottom-[7px] right-4"
          size="small"
        >
          <ArrowBackIosNewRounded />
        </IconButton>
      </div>
    ),
    nextArrow: (
      <div>
        <IconButton
          className="text-gray-400 hover:bg-inherit relative bottom-[7px]"
          size="small"
        >
          <ArrowForwardIosRounded />
        </IconButton>
      </div>
    ),
  };

  return (
    <div className="px-6 max-w-[350px] md:max-w-[500px]">
      {props.list.length > 0 && (
        <Slider {...settings}>
          {props.list.map((item) => (
            <div key={item.id}>
              <div className="flex flex-col py-12 px-6 gap-y-2 bg-white rounded">
                <div className="text-gray-400 flex gap-x-2 items-center">
                  <span>{item.title}</span>
                  <span className="w-1 h-1 rounded-full bg-gray-400" />
                  <span className="text-sm">15min ago</span>
                </div>
                <div className="flex">
                  <div className="flex flex-col gap-y-2 flex-1">
                    <div dangerouslySetInnerHTML={{ __html: item.html }} />
                  </div>
                  <div className="w-[120px] h-[120px]">
                    <img
                      className="w-full h-full"
                      src={dmeConfig.general.imagePath(item.image, "thumbnail")}
                    />
                  </div>
                </div>
              </div>
            </div>
          ))}
        </Slider>
      )}
    </div>
  );
}
